function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icon/Big/HighSun");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "assets",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "styleguide",
  transform: "translate(-126.000000, -711.000000)",
  fill: "#FD9872"
}, React.createElement("g", {
  id: "Icon/Big/HighSun",
  transform: "translate(126.000000, 711.000000)"
}, React.createElement("g", {
  id: "Group-12",
  transform: "translate(0.000000, 1.000000)"
}, React.createElement("path", {
  d: "M35.8860759,56.5949367 L35.8860759,69 L34.1139241,69 L34.1139241,56.5949367 L35.8860759,56.5949367 Z M52.4898987,48.4649241 L61.2611646,57.2361899 L60.0082532,58.4891013 L51.2369873,49.7178354 L52.4898987,48.4649241 Z M18.3961772,48.4649241 L19.6490886,49.7178354 L10.8778228,58.4891013 L9.62491139,57.2361899 L18.3961772,48.4649241 Z M35,14.9493671 C45.0162025,14.9493671 53.164557,23.0977215 53.164557,33.1139241 C53.164557,43.1301266 45.0162025,51.278481 35,51.278481 C24.9837975,51.278481 16.835443,43.1301266 16.835443,33.1139241 C16.835443,23.0977215 24.9837975,14.9493671 35,14.9493671 Z M35,16.721519 C25.9611392,16.721519 18.6075949,24.0750633 18.6075949,33.1139241 C18.6075949,42.1527848 25.9611392,49.5063291 35,49.5063291 C44.0388608,49.5063291 51.3924051,42.1527848 51.3924051,33.1139241 C51.3924051,24.0750633 44.0388608,16.721519 35,16.721519 Z M12.4050633,33.1139241 L12.4050633,34.8860759 L0,34.8860759 L0,33.1139241 L12.4050633,33.1139241 Z M70,33.1139241 L70,34.8860759 L57.5949367,34.8860759 L57.5949367,33.1139241 L70,33.1139241 Z M11.7641646,7.73918987 L20.5354304,16.5104557 L19.282519,17.7633671 L10.5112532,8.99210127 L11.7641646,7.73918987 Z M59.1219114,7.73918987 L60.3748228,8.99210127 L51.603557,17.7633671 L50.3506456,16.5104557 L59.1219114,7.73918987 Z M35.8860759,-1 L35.8860759,11.4050633 L34.1139241,11.4050633 L34.1139241,-1 L35.8860759,-1 Z",
  id: "Combined-Shape"
})))));

var SvgHighSun = function SvgHighSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHighSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/high-sun.e5a22f06.svg";
export { ForwardRef as ReactComponent };